import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IFormData } from '../../flows/achOutTransfer/constants';
import { ContextType, IServerErrorResponse } from '../../types';
import { ContextTypes } from '../../constants/pages';

export interface IAchOutResponse {
  processTime: string;
  status: string;
  transactionId: string;
}

interface IProps {
  customerId: string;
  accountId: string;
  formData: IFormData;
  contextType?: ContextType;
  billId?: string;
  supplierId?: string;
  onSuccess: (data: IAchOutResponse) => void;
  onError: (data: IServerErrorResponse) => void;
}

export const useSendAchOutMutation = ({
  customerId, accountId, formData, contextType = ContextTypes.ACH_OUT, billId, supplierId, onSuccess, onError,
} :IProps) => {
  const {
    transferAmount,
  } = formData;

  const getPayloadData = () => {
    if (contextType === ContextTypes.ACH_OUT || contextType === ContextTypes.BILL_PAY) {
      return {
        amount: Number(transferAmount),
        feeData: formData.feeData,
        supplierId,
      };
    }
    return null;
  };

  const payload = getPayloadData();

  const requestURL = contextType === ContextTypes.BILL_PAY
    ? `${BASE_URL}/api/v1/user/${customerId}/${accountId}/${billId}/ach/out/billPay`
    : `${BASE_URL}/api/v3/user/${customerId}/${accountId}/ach/out`;

  return useMutation(
    'send-ach-out',
    async () => {
      const { data } = await httpService.post(
        requestURL,
        { ...payload },
      );
      return data;
    },
    {
      onSuccess: (data: IAchOutResponse) => {
        onSuccess(data);
      },
      onError: (data: IServerErrorResponse) => {
        onError(data);
      },
    },
  );
};
